import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../CreateCourse/ThreeColumnTableRow';
import {fetchStudyCycle} from "../../Lookups/util";

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class SPDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            englishName: '',
            documentNumber: '',
            studyProgramOrganizationalUnits: '',
            comment: '',
            studyCycle:'',
            orgUnits: [],
            studyCycles:[],

            edit: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.edit = this.edit.bind(this);
    }

    componentDidMount() {
        let orgUnits = [];
        // this.props.studyProgram.studyProgramBasic.organizationalUnits.map(el => (
        //     orgUnits.push(el.id)
        // ));
        this.setState({ orgUnits });

        axios.all([fetchStudyCycle()])
            .then(axios.spread(( studyCyclesRes) => {

                const studyCycles = studyCyclesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({ studyCycles });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch studyCycles');
            });
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    edit() {
        const {
            name, documentNumber, comment, englishName, studyCycle
        } = this.state;

        const { studyProgram } = this.props.location.state;

        if(studyCycle){
            let objAdd = { id: studyProgram.studyProgramBasic.id, studyCycles: [studyCycle]}

            if(studyProgram.studyProgramBasic.studyCycles.length){
                let objRemove = { id: studyProgram.studyProgramBasic.id, studyCycles: [studyProgram.studyProgramBasic.studyCycles[0].id] }
                axios.put(`study-programs/basic/remove-study-cycle`, { ...objRemove })
                    .then(res => {
                        axios.put(`study-programs/basic/add-study-cycle`, { ...objAdd})
                            .then(res => {
                            })
                    })
                    .catch(err => {
                        console.log('error remove study cycle');
                    });
            }
            else {
                axios.put(`study-programs/basic/add-study-cycle`, { ...objAdd})
                    .then(res => {
                    })
                    .catch(err => {
                        console.log('error add study cycle');
                    });

            }

        }

        if (name || documentNumber || comment || englishName) {
            this.setState({ edit: false });
            let editObj = {};

            let language = { twoLetterCode: 'en' };
            let translations = [{ name: englishName, language }];

            if (name) editObj = { ...editObj, name };
            if (documentNumber) editObj = { ...editObj, documentNumber };
            if (comment) editObj = { ...editObj, comment };
            if (englishName) editObj = { ...editObj, translations };

            editObj = { ...editObj, id: studyProgram.studyProgramBasic.id };
            editObj = { ...editObj, optlock: studyProgram.studyProgramBasic.optLock };

            axios.put('study-programs/update-basic', { ...editObj })
                .then(res => {
                    toast('Izmjena studijskog programa je uspješno izvršena.');
                })
                .catch(err => {
                    toast('Došlo je do greške! Izmjena studijskog programa nije uspješno izvršena.');
                });
        }

        if(name || documentNumber || comment || englishName || studyCycle){
            window.history.go(-1);
        }
        else {
            toast('Morate unijeti nove podatke ukoliko želite izvršiti izmjenu!');
        }

    }

    render() {
        const { studyProgram } = this.props.location.state;
        return (
            <div>
                <Header as="h1">Studijski program</Header>

                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3" >
                            {studyProgram.studyProgramBasic.name}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Table celled unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <ThreeColumnTableRow
                                    name="Naziv"
                                    keyName="name"
                                    value={studyProgram.studyProgramBasic.name}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={studyProgram.studyProgramBasic.name}
                                />
                                <ThreeColumnTableRow
                                    name="Naziv na engleskom"
                                    keyName="englishName"
                                    value={studyProgram.studyProgramBasic.translations.length ? studyProgram.studyProgramBasic.translations.find(e => e.language === 'en').name : null}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={studyProgram.studyProgramBasic.translations.length ? studyProgram.studyProgramBasic.translations.find(e => e.language === 'en').name : null}
                                />
                                <ThreeColumnTableRow
                                    name="Broj odluke"
                                    keyName="documentNumber"
                                    value={studyProgram.studyProgramBasic.documentNumber}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={studyProgram.studyProgramBasic.documentNumber}
                                />
                                <ThreeColumnTableRow
                                    name="Ciklus studija"
                                    keyName="studyCycle"
                                    value={studyProgram.studyProgramBasic.studyCycles[0].displayName}
                                    onChange={this.handleInputChange}
                                    edit={this.state.edit}
                                    studyCycles={this.state.studyCycles}
                                    defValue={studyProgram.studyProgramBasic.studyCycles[0].id}
                                />
                                <ThreeColumnTableRow
                                    name="Napomena"
                                    keyName="comment"
                                    value={studyProgram.studyProgramBasic.comment}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={studyProgram.studyProgramBasic.comment}
                                />
                            </Table.Body>
                        </Table>
                        {!this.state.edit ?
                            <Button floated="right" primary onClick={() => this.setState({ edit: true })}>Izmijeni</Button>
                            : <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                                <Button
                                    floated="right"
                                    primary
                                    onClick={this.edit}
                                >Sačuvaj izmjene</Button>
                            </div>}
                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/SPDetails.js